import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

// components
// import Countdown from 'react-countdown';

import {Typography , Stack, Grid, Button , Box , CircularProgress} from '@mui/material';

import Page from '../../components/Page';
import img from './osoul-offer.png'


export default function Offers() {

  const [loading, setLoading] = React.useState(false);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const getBundelsData = async () => {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${userInfo?.access}`,
      },
    };
    setLoading(true);
    const url = `${process.env.REACT_APP_API_KEY}/api/v1/files/deposit-kashier/3/`;
    const Body = {};
    axios
      .post(url, Body, config)
      .then((result) => {
        const responseUrl = result.data.redirect_iframe_url;
        setLoading(false);
        window.location.replace(responseUrl);
      
      })
      .catch((error) => {
        console.log(error);
      });
    setLoading(true);
  };

  return (
    <Page title="Help Center" >
            <Stack container justifyContent="center" alignItems="center" sx={{p:1 , direction:'rtl'}}>
            <Stack item xs={12} sx={{width:"100%"  , alignItems:'center', minHeight:50, bgcolor:'green'}}>
              <Box >
                 <Typography variant='h4' sx={{fontSize:'2rem', fontWeight:'bold', color:'white', pt:1, fontFamily:'Cairo'}}>عرض خــــاص جدا .</Typography>

               </Box>
               </Stack >

               
                          <Grid item xs={12} justifyContent="space-between"  sx={{ direction:'rtl' , margin:2 , padding:2 }} >
                          <Box direction="column" textAlign='center'  display='flex' alignItems='center' justifyContent='center'>
                          <Typography sx={{fontSize:'1.2rem' , fontWeight:'600' , pt:1}}>احصل علي 5000 كوينز صالح للإستخدام في اي وقت مقابل 14.9 دولار ،، او 460 جنيه مصري </Typography>
                          </Box>
                       
                            
                    </Grid>
                    <Grid item xs={12} maxHeight="400px" >
                            <img style={{maxHeight:'400px'}} src={img} alt="green iguana"/>
                            </Grid>
                    {loading && <CircularProgress sx={{width:'1rem', height:'1rem', color:'green'}}/>}
                    {!loading && !userInfo && <Button sx={{minWidth:'50%', fontSize:'1.3rem' , m:2}} variant="outlined"  to={'/login'} >سجل دخول للحصول على العرض</Button>}
                    {!loading && userInfo && <Button sx={{minWidth:'50%', fontSize:'1.3rem' , m:2}} variant="outlined"  onClick={() => getBundelsData()}>إشتـــــري الان</Button>}
                    </Stack> 
                    <Stack>
                          <Typography variant='h5' sx={{fontSize:'lg' , fontWeight:'600' , pt:1}}>تذكر ان العرض سينتهي قريب جدا ،،، ولكن رصيدك سيظل صالح مدي الحياة </Typography>
                          <Typography variant='h6' sx={{fontSize:'lg' , fontWeight:'600' , pt:1}}>يمكنك ايضا شحن محفظتك من خلال فودافون كاش أو محفظة الهاتف ،،، فقط راسلنا علي واتس اب 01124882882 </Typography>                
                    </Stack>
                               
                
    </Page>
  );
}
